/**
 *  CircleSuccessComponent provides the basic succes image component.
 *
 *  @author Gisler Garces <ggarces@alertlogic.com>
 *
 *  @copyright Alert Logic, Inc 2017
 *
 * Sample about how to use it
 *    <circle-success></circle-success>
 */
import { Component } from '@angular/core';

@Component({
    selector: 'circle-success',
    templateUrl: './circle-success.component.html',
    styleUrls: ['./circle-success.component.scss']
})
export class CircleSuccessComponent { }
